import { FC } from 'react';
import { ServicesAll } from './ServicesAll/ServicesAll';
import { TenantSyncGate } from '@/components/projects/TenantSyncGate/TenantSyncGate';
import { PageTemplate } from '@/components/uiParts/Template/PageTemplate/PageTemplate';

export const ServicesAllPage: FC = () => {
  return (
    <TenantSyncGate>
      <PageTemplate pageName="servicesAll" title="サービス" showNavBack>
        <ServicesAll />
      </PageTemplate>
    </TenantSyncGate>
  );
};
